// extracted by mini-css-extract-plugin
export default {"logoWrapper":"OrganizationPortfolioView_logoWrapper__9rb1-","organizationImage":"OrganizationPortfolioView_organizationImage__Bqg9X"};